export default "__VITE_ASSET__CPcOlFvX__"